<template>
  <div class="tab-content">
    <el-form ref="form" label-width="80px" label-position="top" size="small">
      <el-row :gutter="15">
        <el-col :span="24">
          <el-form-item label="Discography">
            <el-button class="el-btn-blue" size="mini" icon="el-icon-plus" @click="newDiscography()" style="margin-bottom: 10px;">New Discography</el-button>
            <div class="main-table">
              <el-table :data="discographies" border size="small">
                <el-table-column prop="artist" label="Artist"></el-table-column>
                <el-table-column prop="song" label="Song"></el-table-column>
                <el-table-column prop="producer_engineer" label="Producer/Engineer"></el-table-column>
                <el-table-column prop="instruments" label="Instruments"></el-table-column>
                <el-table-column label="Spotify Link">
                  <template #default="scope">
                    <el-link type="primary" :underline="false" :href="scope.row.spotify_link" target="_blank">{{ scope.row.spotify_link }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column label="TIDAL Link">
                  <template #default="scope">
                    <el-link type="primary" :underline="false" :href="scope.row.tidal_link" target="_blank">{{ scope.row.tidal_link }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column label="Operate">
                  <template #default="scope">
                    <div class="table-operate">
                      <div class="operate-item">
                        <el-button size="small" type="text" class="el-btn-blue" @click="editDiscography(scope.$index, scope.row)">Edit</el-button>
                      </div>
                      <div class="operate-item">
                        <el-popconfirm
                          title="Confirm to delete this record?"
                          @confirm="deleteDiscography(scope.$index)"
                        >
                          <template #reference>
                            <el-button size="small" type="text" class="el-btn-blue">Delete</el-button>
                          </template>
                        </el-popconfirm>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updateProduct" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <ModalDiscography
      v-bind:flagVisible="flagVisible.modalDiscography" v-on:closeModal="flagVisible.modalDiscography = false"
      v-bind:actionIndex="actionItems.index" v-bind:actionItem="actionItems.discography" v-on:updateData="updateData"
    />
  </div>
</template>

<script>
import { reactive } from 'vue'
import ModalDiscography from './ModalDiscography.vue'
const spotifyUri = require('spotify-uri')
export default {
  name: 'TabAudio',
  props: {
    tab: String,
    tabUpdate: Boolean,
    role: String,
    actionItem: Object
  },
  emits: ['changeSaveTab'],
  components: {
    ModalDiscography
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
      modalDiscography: false
    })
    const actionItems = reactive({
      index: -1,
      discography: {}
    })
    return {
      product: {},
      discographies: [],
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.product = { ...val }
          if (val && val.discography) this.discographies = [...val.discography]
        }
      },
      deep: true
    },
    tabUpdate: {
      handler: function (val, oldVal) {
        if (val !== oldVal && val && this.tab === 'Discography') {
          this.updateProduct()
          this.$emit('changeSaveTab', '')
        }
      },
      deep: true
    }
  },
  methods: {
    updateProduct: function () {
      this.$emit('changeSaveTab', '')
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/products/${this.product._id}`
      const that = this
      const body = { type: 'discography', content: this.discographies }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateProduct', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    newDiscography: function () {
      if (this.actionItems.index >= 0) {
        this.actionItems.discography = {}
        this.actionItems.index = -1
      }
      this.flagVisible.modalDiscography = true
    },
    editDiscography: function (index, discography) {
      if (this.actionItems.index !== index) {
        this.actionItems.discography = { ...discography }
        this.actionItems.index = index
      }
      this.flagVisible.modalDiscography = true
    },
    deleteDiscography: function (index) {
      this.triggerTabUpdate()
      this.discographies.splice(index, 1)
    },
    updateData: function (index, discography) {
      this.triggerTabUpdate()
      try {
        const parsed = spotifyUri.parse(discography.spotify_link)
        console.log('updateData', parsed)
        if (parsed.type && parsed.id) {
          discography.spotify_link = `spotify:${parsed.type}:${parsed.id}`
        }
      } catch (err) {
        console.log('spotifyUri', err)
      }
      if (index >= 0) {
        this.discographies[index] = { ...discography }
      } else {
        this.discographies.push({ ...discography })
        this.actionItems.index = this.discographies.length - 1
      }
      this.flagVisible.modalDiscography = false
    },
    triggerTabUpdate: function () {
      this.$emit('changeSaveTab', 'Discography')
    }
  }
}
</script>
